var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{staticClass:"esh-theme"},[_c('v-toolbar',{attrs:{"height":"22"}},[_c('v-toolbar-items',_vm._l((_vm.items),function(item,idx){return _c('v-btn',{key:idx,attrs:{"to":{ name: item.name }}},[_vm._v(_vm._s(item.meta.label || ''))])}),1)],1),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }